import apolloClient from '../../apolloClient';
import placeQueries from '../queries/place';
import placeMutations from '../mutations/place';

const getPlacesByWorkspace = async (variables) =>
  apolloClient.query({
    query: placeQueries.GET_DEVICE_PLACE_BY_WORKSPACE,
    variables,
    fetchPolicy: 'no-cache',
  });

const deletePlaceById = async (variables) =>
  apolloClient.mutate({
    mutation: placeMutations.DELETE_PLACE_BY_ID,
    variables,
    fetchPolicy: 'no-cache',
  });

export default {
  getPlacesByWorkspace,
  deletePlaceById,
};
